module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@3x-eed7c92a38bed0ccff2e803cf8ea8c83.png";